import React, { createContext, useContext, useState, useEffect } from 'react';

export const SUPPORTED_LANGUAGES = {
  en: 'English',
  cs: 'Čeština'
};

export function detectLanguage() {
  const browserLang = navigator.language.split('-')[0].toLowerCase();
  return SUPPORTED_LANGUAGES[browserLang] ? browserLang : 'en';
}

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(detectLanguage());
  const [translations, setTranslations] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTranslations = async () => {
      try {
        const response = await fetch('/locales/translations.json');
        if (!response.ok) {
          throw new Error(`Failed to load translations: ${response.status}`);
        }
        const data = await response.json();
        console.log('Loaded translations:', data);
        setTranslations(data);
      } catch (error) {
        console.error('Error loading translations:', error);
      } finally {
        setLoading(false);
      }
    };

    loadTranslations();
  }, []);

  const t = (key) => {
    if (!translations || !translations[language]) {
      console.log('No translations available for:', language);
      return key;
    }

    // Split the key by dots and traverse the translations object
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation missing for key: ${key} in language: ${language}`);
        // Fallback to English if the key doesn't exist in the current language
        if (language !== 'en' && translations.en) {
          let enValue = translations.en;
          for (const k of keys) {
            if (enValue && typeof enValue === 'object' && k in enValue) {
              enValue = enValue[k];
            } else {
              console.warn(`Translation also missing in English for key: ${key}`);
              return key;
            }
          }
          return enValue;
        }
        return key;
      }
    }
    
    return value;
  };

  if (loading) {
    return <div>Loading translations...</div>;
  }

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
}
